
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting errors returned when invalid parameters are supplied in the Sandbox environment.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Sandbox errors' subtitle='Guide to troubleshooting Sandbox errors' mdxType="Header" />
    <h4 {...{
      "id": "sandbox_product_not_enabled"
    }}><strong parentName="h4">{`SANDBOX_PRODUCT_NOT_ENABLED`}</strong></h4>
    <ErrorReference type='SANDBOX_ERROR' error='SANDBOX_PRODUCT_NOT_ENABLED' subtitle='The requested product is not enabled for an Item' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`A Sandbox operation could not be performed because a product has not been enabled on the Sandbox Item.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='SANDBOX_PRODUCT_NOT_ENABLED' mdxType="Checkbox">
        <p>{`Verify that you are enabled for the requested product in your `}<a parentName="p" {...{
            "href": "https://dashboard.plaid.com"
          }}>{`Dashboard`}</a>{`.`}</p>
      </Checkbox>
      <p>{`If the error persists, submit a `}<a parentName="p" {...{
          "href": "https://dashboard.plaid.com/support/new/"
        }}>{`Support`}</a>{` ticket.`}</p>
    </ErrorReference>
    <h4 {...{
      "id": "sandbox_webhook_invalid"
    }}><strong parentName="h4">{`SANDBOX_WEBHOOK_INVALID`}</strong></h4>
    <ErrorReference type='SANDBOX_ERROR' error='SANDBOX_WEBHOOK_INVALID' subtitle='The request to fire a Sandbox webhook failed.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The webhook for the Item sent in the `}<inlineCode parentName="li">{`/sandbox/item/fire_webhook`}</inlineCode>{` request is not set or is invalid.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='SANDBOX_WEBHOOK_INVALID' mdxType="Checkbox">
        <p>{`Set a valid webhook for the Item — for an existing Item, use `}<a parentName="p" {...{
            "href": "/docs/api/items/#itemwebhookupdate"
          }}><inlineCode parentName="a">{`/item/webhook/update`}</inlineCode></a>{` — then retry the request.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "sandbox_transfer_event_transition_invalid"
    }}><strong parentName="h4">{`SANDBOX_TRANSFER_EVENT_TRANSITION_INVALID`}</strong></h4>
    <ErrorReference type='SANDBOX_ERROR' error='SANDBOX_TRANSFER_EVENT_TRANSITION_INVALID' subtitle='The `/sandbox/transfer/simulate` endpoint was called with parameters specifying an invalid event transition.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-2"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The `}<inlineCode parentName="li">{`/sandbox/transfer/simulate`}</inlineCode>{` endpoint was called with parameters specifying an invalid event transition.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-2"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='SANDBOX_TRANSFER_EVENT_TRANSITION_INVALID' mdxType="Checkbox">
        <p>{`Ensure the sequence of events specified via `}<inlineCode parentName="p">{`/sandbox/transfer/simulate`}</inlineCode>{` is valid.`}</p>
        <p>{`Compatible status --> event type transitions include:`}</p>
        <p><inlineCode parentName="p">{`pending`}</inlineCode>{` --> `}<inlineCode parentName="p">{`failed`}</inlineCode></p>
        <p><inlineCode parentName="p">{`pending`}</inlineCode>{` --> `}<inlineCode parentName="p">{`posted`}</inlineCode></p>
        <p><inlineCode parentName="p">{`posted`}</inlineCode>{` --> `}<inlineCode parentName="p">{`failed`}</inlineCode>{` (RfP only)`}</p>
        <p><inlineCode parentName="p">{`posted`}</inlineCode>{` --> `}<inlineCode parentName="p">{`returned`}</inlineCode></p>
        <p><inlineCode parentName="p">{`posted`}</inlineCode>{` --> `}<inlineCode parentName="p">{`settled`}</inlineCode></p>
        <p><inlineCode parentName="p">{`settled`}</inlineCode>{` --> `}<inlineCode parentName="p">{`returned`}</inlineCode></p>
        <p><inlineCode parentName="p">{`settled`}</inlineCode>{` --> `}<inlineCode parentName="p">{`funds_available`}</inlineCode>{` (debit transfers over ACH, Same-Day ACH, or RfP only)`}</p>
        <p><inlineCode parentName="p">{`funds_available`}</inlineCode>{` --> `}<inlineCode parentName="p">{`returned`}</inlineCode></p>
      </Checkbox>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "sandbox_product_not_enabled",
        level: 4,
        title: "SANDBOX_PRODUCT_NOT_ENABLED",
      },
{
        id: "sandbox_webhook_invalid",
        level: 4,
        title: "SANDBOX_WEBHOOK_INVALID",
      },
{
        id: "sandbox_transfer_event_transition_invalid",
        level: 4,
        title: "SANDBOX_TRANSFER_EVENT_TRANSITION_INVALID",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
